import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { appDependencies } from '@/app/dependencies'
import type { SetAppModuleActiveCommand } from '../domain/moduleVisibility'

export const moduleVisibilityQueryKey = ['settings', 'app-modules'] as const

export function useModuleVisibilityList() {
  return useQuery({
    queryKey: moduleVisibilityQueryKey,
    queryFn: () => appDependencies.moduleVisibility.listModules(),
  })
}

export function useSetModuleActive() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (command: SetAppModuleActiveCommand) =>
      appDependencies.moduleVisibility.setModuleActive(command),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: moduleVisibilityQueryKey })
    },
  })
}
